import { render, staticRenderFns } from "./LeaderboardContent.vue?vue&type=template&id=7fe05956&scoped=true&"
import script from "./LeaderboardContent.vue?vue&type=script&lang=js&"
export * from "./LeaderboardContent.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardContent.vue?vue&type=style&index=0&id=7fe05956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe05956",
  null
  
)

export default component.exports